module.exports = __webpack_public_path__ + "static/media/social-ig-white.18fa1d6f.svg";